import React from 'react';
import { RENDERABLE } from '../../../lib/propTypes';
import classes from './index.module.scss';

const Footer = ({ children }) => (
    <footer className={`${classes.contentFooter} modal-content-footer`}>{children}</footer>
);

Footer.propTypes = {
    children: RENDERABLE.isRequired
};

export default Footer;
